import React from "react";
import styled, { css } from "styled-components";
import { DetailedCourse } from "@domain/lms/course/course";
import { ImageSection } from "@domain/lms/course/courseSection";
import { getAssetById } from "@domain/lms/course/utils";
import { ImageVersions } from "@domain/media/dtos";
import { ImageView } from "@ui/components/media/imageView";

interface ImageSectionViewProps extends React.HTMLAttributes<HTMLDivElement> {
	section: ImageSection;
	course: DetailedCourse;
}
export const ImageSectionView: React.FC<ImageSectionViewProps> = ({ section, course, ...htmlProps }) => {
	const asset = getAssetById(course.content, section.assetId);

	if (!asset) {
		return null;
	}
	return (
		<Container {...htmlProps}>
			<ImageView image={asset} imageStyle={imageStyle} imageVersion={ImageVersions.LARGE} />
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	border-radius: 12px;
	overflow: hidden;
	background-color: ${({ theme }) => theme.colors.white};
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const imageStyle = css`
	width: auto;
	max-width: 100%;
	max-height: 400px;
`;
